import LoadingSpinner from "@/components/general/loading-spinner/LoadingSpinner";
import { Section } from "@/components/general/section";
import { Typo } from "@pepperstone/pepper-ui-kit";
import styles from "./LoadingScreen.module.css";

type LoadingScreenProps = {
  description: string;
};
export const LoadingScreen = ({ description }: LoadingScreenProps) => {
  return (
    <Section className={styles.container}>
      <LoadingSpinner />
      <Typo elem="p" type="body" size="md">
        {description}
      </Typo>
    </Section>
  );
};
